import React from 'react'
import { IconButton, withStyles } from '@material-ui/core'
import { CloseIcon } from 'asterX-UI/Icons'
import { iconCloseButtonStyle } from './buttons.styles'

const IconCloseButton = withStyles(iconCloseButtonStyle)(props => {
  const { children, classes, ...other } = props
  return (
    <IconButton classes={classes} {...other}>
      <CloseIcon />
    </IconButton>
  )
})
export default IconCloseButton
